import Error from 'components/alerts/Error';
import Success from 'components/alerts/Success';
import { Text } from 'components/common/form/modules/input/Text';
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import React from 'react'
import { Label } from 'reactstrap'
import { fetchGraphQL } from 'services/graphql/GraphQL';

export default class CustomizeSubdomain extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props);
        this.state = {
            subdomain: '',
            success: false,
            error: false,
            errorMessage: '',
            remove: false,
            customizedAlready: false
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.removeSubdomain = this.removeSubdomain.bind(this);
    }

    public componentDidMount() {
        this.setState({
            subdomain: this.props.subdomain,
            customizedAlready: this.props.subdomain !== '' ? true : false
        })
    }

    public handleInputChange(e) {

        // console.log(e.target.value)
        if (e.target.value.includes('.') || e.target.value.includes('@')) {
            return;
        }

        this.setState({
            subdomain: e.target.value ? e.target.value.toLowerCase() : '',
            error: false,
            success: false,
            errorMessage: ''
        })
    }

    public handleSubmit() {
        if (this.state.subdomain === '') {
            this.setState({
                error: true,
                errorMessage: 'Please enter a valid subdomain'
            })
            return;
        } else if (this.state.subdomain === this.props.subdomain) {
            this.setState({
                error: true,
                errorMessage: 'Custom prefix already in use'
            })
            return;
        }

        fetchGraphQL(`
        mutation{
            url {
                updateSubdomain(eventId:"${this.props.eventId}",subdomain:"${this.state.subdomain.split(' ').join()}")
            }
        }`).then(res => {
            if (res && res.url && res.url.updateSubdomain) {
                this.setState({ success: true })
            } else {
                this.setState({ error: true, errorMessage: 'Subdomain in use for another event' })
            }
        })
    }

    public removeSubdomain() {
        fetchGraphQL(`
        mutation{
            url {
                removeSubdomain(eventId:"${this.props.eventId}")
            }
        }`).then(res => {
            if (res && res.url && res.url.removeSubdomain) {
                window.location.reload()
            } else {
                this.setState({ error: true, errorMessage: 'An error occurred.' })
            }
        })
    }

    public render() {
        return <div>
            <Label className="sexyBlack">
                For example, if you enter 'abc', your general ticket link will be: abc.isotopeticketing.com<br />
            </Label>
            <Text
                // label=""
                value={this.state.subdomain}
                name="subdomain"
                onChange={this.handleInputChange}
            />
            <br />
            {
                this.state.error ?
                    <Error content={this.state.errorMessage} /> : null
            }
            {
                this.state.success ?
                    <Success content={'URL customized successfully!'} /> : null
            }
            {
                this.state.remove ?
                    <Success content={'URL back to default.'} /> : null
            }
            <br />
            {
                this.state.customizedAlready ?
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <button
                            className="new-button-white-4"
                            style={{ border: 'none' }}
                            onClick={e => this.removeSubdomain()}
                        >
                            REMOVE
                    </button>
                        <br />
                        <br />
                    </div> : null
            }
            {
                this.state.success ?
                    <div className="Seperate-Buttons">
                        <button
                            className="new-button-white-3"
                            style={{ border: 'none' }}
                            onClick={e => window.location.reload()}
                        >
                            DONE
                    </button>
                    </div>
                    :
                    <div className="Seperate-Buttons">
                        <button
                            className='new-button-white-3'
                            style={{ border: 'none' }}
                            onClick={closeModal}
                        >
                            CANCEL
                        </button>
                        <button
                            className="new-button-white-3"
                            style={{ border: 'none' }}
                            onClick={this.handleSubmit}
                        >
                            CUSTOMIZE
                        </button>
                    </div>
            }
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/modules/ticketInventory/CustomizeSubdomain.tsx